import Vue from 'vue'
import Amplify, * as AmplifyModules from './finAmplifyModules'
import {AmplifyPlugin} from 'aws-amplify-vue'



import aws_config from '@/aws-exports'
//import aws_config from '@/fin-api-exports'

//duplicate conf and remove analytics params, so that no localstorage cookies are written
//disable of analytics still write this storage cookie
const config = {...aws_config}
config.API = {
  graphql_headers: async () => {
    // FINDEV-2515
    // https://github.com/aws-amplify/amplify-js/issues/3326
    // https://docs.amplify.aws/lib/graphqlapi/authz/q/platform/js/#cognito-user-pools
    try{
      //
      const session = await AmplifyModules.Auth.currentSession() //throws a exception if its not a signed in user
      return {
         Authorization: session.getIdToken().getJwtToken(),
      }
    }catch (e){
      //use defaults if the user not signed in, that the default token is used
      return {}
    }
  },
}
const analyticsConfig = {
  aws_mobile_analytics_app_id: aws_config.aws_mobile_analytics_app_id,
  aws_mobile_analytics_app_region: aws_config.aws_mobile_analytics_app_region
}
delete config.aws_mobile_analytics_app_id
delete config.aws_mobile_analytics_app_region

config["aws_appsync_graphqlEndpoint"] = process.env.VUE_APP_AWS_APPSYNC_ENDPOINT
config["aws_appsync_region"] = "eu-central-1"
config["aws_appsync_authenticationType"] = "AMAZON_COGNITO_USER_POOLS"

const userToLowerCase = (params) => {
  if (params && typeof params === 'string') {
    params = params.toLowerCase()
  } else {
    if (params?.username) {
      params.username = params.username.toLowerCase()
    }
    // using email as login field, it has to have to same value as the username
    if (params?.attributes?.email) {
      params.attributes.email = params.attributes.email.toLowerCase()
    }
  }

  return params
}

// override signIn with username to lowercase
const orgSignIn = AmplifyModules.Auth.signIn
AmplifyModules.Auth.signIn = (usernameOrSignInOpts, password) => orgSignIn.call(AmplifyModules.Auth, userToLowerCase(usernameOrSignInOpts), password)

// override signUp with username + email to lowercase
const orgSignUp = AmplifyModules.Auth.signUp
AmplifyModules.Auth.signUp = (params, restOfAttrs) => orgSignUp.call(AmplifyModules.Auth, userToLowerCase(params), restOfAttrs)


AmplifyModules.Analytics.disable()
Amplify.configure(config)
AmplifyModules.Auth.configure(config)


let initAnalyticsDone=false
function initAnalytics(){
  if(initAnalyticsDone) return
  initAnalyticsDone=true

  console.log('init Analytics')
  AmplifyModules.Analytics.autoTrack('pageView', {
    // REQUIRED, turn on/off the auto tracking
    enable: true,
    // OPTIONAL, the event name, by default is 'pageView'
    eventName: 'pageView',
    // OPTIONAL, the attributes of the event, you can either pass an object or a function
    // which allows you to define dynamic attributes
    //attributes: {
    //  attr: 'attr'
    //},
    // when using function
    // attributes: () => {
    //    const attr = somewhere();
    //    return {
    //        myAttr: attr
    //    }
    // },
    // OPTIONAL, by default is 'multiPageApp'
    // you need to change it to 'SPA' if your app is a single-page app like React
    type: 'SPA',
    // OPTIONAL, the service provider, by default is the Amazon Pinpoint
    provider: 'AWSPinpoint',
    // OPTIONAL, to get the current page url
    getUrl: () => {
      // the default function
      return window.location.origin + window.location.pathname
    }
  })

  Amplify.configure(analyticsConfig)
}

function updateAnalytics(){
  if (window.Cookiebot.consent.statistics) {
    initAnalytics()
    console.log('enable Analytics')
    AmplifyModules.Analytics.enable()
  } else {
    console.log('disable Analytics')
    AmplifyModules.Analytics.disable()
  }
}

updateAnalytics()
window.addEventListener('CookiebotOnAccept', updateAnalytics, false)
window.addEventListener('CookiebotOnDecline', updateAnalytics, false)

Vue.use(AmplifyPlugin, AmplifyModules)

export default {}
